import { render, staticRenderFns } from "./k-form-search-customize.vue?vue&type=template&id=6c57ce50"
import script from "./k-form-search-customize.vue?vue&type=script&lang=js"
export * from "./k-form-search-customize.vue?vue&type=script&lang=js"
import style0 from "./k-form-search-customize.vue?vue&type=style&index=0&id=6c57ce50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports